
const server = "https://server.fujisushi.no"
//const server = "https://testserver.fujisushi.no"
//const server = "http://192.168.0.2:5000"

//const baseUrl = "https://server.fujisushi.no/api";
//const baseUrl = "https://testserver.fujisushi.no/api";
//const baseUrl = "http://localhost:5000/api";
//const baseUrl = "http://192.168.0.2:5000/api";

//const authUrl = "https://server.fujisushi.no/api/restaurantmanagers/auth";
//const authUrl = 'https://testserver.fujisushi.no/api/restaurantmanagers/auth';
//const authUrl = 'http://localhost:5000/api/restaurantmanagers/auth';
//const authUrl = 'http://192.168.0.2:5000/api/restaurantmanagers/auth';

//const orderMessagesUrl = 'http://localhost:5000/ordermessages';
//const orderMessagesUrl = 'http://192.168.0.2:5000/ordermessages';
//const orderMessagesUrl = 'https://etakeawayprod.azurewebsites.net/ordermessages';
//const orderMessagesUrl = 'https://etakeawaystage.azurewebsites.net/ordermessages';
//const orderMessagesUrl = 'https://testserver.fujisushi.no/ordermessages';

const baseUrl = server;
const authUrl = `${baseUrl}/api/restaurantmanagers/auth`;
const orderMessagesUrl = `${baseUrl}/ordermessages`;

const ordermanagerUrl = `${baseUrl}/api/ordermanagement`;
//const ordermanagerUrl = `${baseUrl}/api/ordermanagementtest`;
const printingUrl = `${baseUrl}/api/printing`;
const orderingUrl = `${baseUrl}/api/ordering`;
//const orderingUrl = `${baseUrl}/api/orderingtest`;
const productsUrl = `${baseUrl}/api/items`;
const taxesUrl = `${baseUrl}/api/taxes`;
const categoriesUrl = `${baseUrl}/api/categories`;
const menusUrl = `${baseUrl}/api/menus`;
const imagesUrl = `${baseUrl}/api/images`;
const openingTimeTableUrl = `${baseUrl}/api/openingtimetables`; 
const pickupNumbersUrl = `${baseUrl}/api/pickupnumbers`;
const restaurantsUrl = `${baseUrl}/api/restaurants`;
const orderByPhonesUrl = `${baseUrl}/api/orderbyphone`;
const ordersUrl = `${baseUrl}/api/orders`;
const messageUrl = `${baseUrl}/api/messaging`

export {
    authUrl,
    baseUrl,
    ordermanagerUrl,
    orderingUrl, 
    menusUrl,
    orderMessagesUrl,
    productsUrl,
    categoriesUrl,
    taxesUrl,
    imagesUrl,
    openingTimeTableUrl,
    pickupNumbersUrl,
    restaurantsUrl,
    orderByPhonesUrl,
    ordersUrl,
    printingUrl,
    messageUrl
}